"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-MapModeLegendContainer',
    legendItem: 'c-MapModeLegendItem',
    legendIcon: 'c-MapModeLegendItem__icon',
    legendText: 'c-MapModeLegendItem__text',
    legendIconLine: 'c-MapModeLegendItem__icon__line',
    legendCollectionLabelOverride: 'c-MapModeLegendItem__icon__label',
};
exports.Style = {
    [exports.CSS.container]: {
        position: 'relative',
        flexGrow: '1',
        maxHeight: '30%',
        padding: theme_1.DefaultTheme.space(1),
        overflow: 'auto',
    },
    [exports.CSS.legendItem]: {
        display: 'flex',
        height: '28px',
        boxSizing: 'border-box',
        padding: `${theme_1.DefaultTheme.space(1)} ${theme_1.DefaultTheme.space(2)}`,
    },
    [exports.CSS.legendIcon]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '32px',
        height: '100%',
    },
    [exports.CSS.legendIconLine]: {
        height: '4px',
        width: '100%',
    },
    [exports.CSS.legendCollectionLabelOverride]: {
        width: '100%',
        padding: 0,
        textAlign: 'center',
    },
    [exports.CSS.legendText]: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '12px',
    },
};
//# sourceMappingURL=map.mode.legend.style.js.map